import { FETCH_WAREHOUSE_ITEMS_SEARCH_RESULTS } from "../../../../../graphql/query/WarehouseItem";
import { warehouseFilterStore } from "../../../components/useWarehouseFilter";

const SearchedWarehouses = props => {
  const tableProps = {
    dataKey: "warehouseItemsV2",
    FETCH_QUERY: FETCH_WAREHOUSE_ITEMS_SEARCH_RESULTS,
    variables: {
      ...warehouseFilterStore.get(),
    },
  };

  return tableProps;
};

export default SearchedWarehouses;
